import classNames from 'classnames';
import React, { FC, useRef } from 'react';
import { TooltipComponent } from 'src/common/tooltip/component';
import { ChevronDownStrongIcon, ChevronUpStrongIcon, UpRegularIcon, UpStrongIcon } from 'src/monet/icons';

type EditorInsightsAggregateMetricsCardProps = {
  label1: string;
  label2: string;
  tooltip?: string;
  delta?: number;
};

export const EditorInsightsAggregateMetricsCard: FC<EditorInsightsAggregateMetricsCardProps> = ({
  label1,
  label2,
  tooltip,
  delta,
}) => {
  const tooltipHoverTargetRef = useRef(null);
  const label1Element = <div className='text-bedrock-serif-h1'>{label1}</div>;
  return (
    <div className='flex flex-col items-start' ref={tooltipHoverTargetRef}>
      <div className='flex items-center gap-2'>
        {tooltip ? (
          <TooltipComponent
            placement='top'
            tooltipContent={tooltip}
            hoverTargetRef={tooltipHoverTargetRef}
            styling='tooltip'
            theme='journey'
          >
            {label1Element}
          </TooltipComponent>
        ) : (
          label1Element
        )}
        {delta ? (
          <TooltipComponent
            placement='top'
            tooltipContent='Metric delta compared to previous time period'
            styling='tooltip'
            theme='journey'
          >
            <div className='flex items-center gap-0.5'>
              <div className='text-bedrock-p-small-strong text-bedrock-black'>{Math.abs(delta)}</div>
              <UpStrongIcon
                className={classNames('w-2 h-2', {
                  'text-bedrock-green rotate-45': delta > 0,
                  'text-bedrock-red rotate-[135deg]': delta < 0,
                })}
              />
            </div>
          </TooltipComponent>
        ) : null}
      </div>
      <div className='text-bedrock-p-small'>{label2}</div>
    </div>
  );
};
